import ListItemButton from "@mui/joy/ListItemButton";
import ListItemContent from "@mui/joy/ListItemContent";
import ListItemDecorator from "@mui/joy/ListItemDecorator";
import Typography from "@mui/joy/Typography";
import { memo } from "react";
import { useRecoilValue } from "recoil";
import useOpenTask from "hooks/useOpenTask";
import { userAtom } from "recoil/userAtom";
import { IncompleteChip, LockChip } from "./TaskChip";
import { Box, Stack } from "@mui/joy";
import useGetTaskTitleFromTaskKey from "hooks/useGetTaskTitleFromTaskKey";

const MapIcon = () => {
  return (
    <svg
      width="10"
      height="11"
      viewBox="0 0 10 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 1V10"
        stroke="#479683"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
      <path
        d="M1 8V7C1 5.89543 1.89543 5 3 5H7C8.10457 5 9 5.89543 9 7V8"
        stroke="#479683"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
    </svg>
  );
};
const ProgressIcon = () => {
  return (
    <svg
      width="10"
      height="9"
      viewBox="0 0 10 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 1L1.64327 3.57309C2.02032 5.08126 3.90074 5.59926 5 4.5V4.5C6.09926 3.40074 7.97968 3.91874 8.35673 5.42691L9 8"
        stroke="#479683"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
    </svg>
  );
};
const CheckIcon = () => {
  return (
    <svg
      width="8"
      height="7"
      viewBox="0 0 8 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 3L3.5 6L7 1"
        stroke="#479683"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

function TaskItem({
  taskKey,
  isDone,
  isLocked,
  hasMissingValue,
}: {
  taskKey: string;
  isDone?: boolean;
  isLocked?: boolean;
  hasMissingValue?: boolean;
}) {
  const openTask = useOpenTask(`${taskKey}`);
  const openPayment = useOpenTask("payment");
  const user = useRecoilValue(userAtom);
  const isCoach = user?.role !== "patient";

  const title = useGetTaskTitleFromTaskKey(taskKey);

  const isCustomIcon =
    taskKey === "dashboard" ||
    taskKey === "thoughtmap" ||
    taskKey === "progress";

  return (
    <ListItemButton
      onClick={() => {
        (document.activeElement as HTMLElement)?.blur();
        if (isLocked) {
          openPayment();
        } else {
          openTask();
        }
      }}
    >
      <ListItemDecorator sx={{ "--ListItemDecorator-size": "28px" }}>
        <Box
          sx={{
            width: "20px",
            height: "20px",
            p: "2px",
          }}
        >
          <Stack
            sx={{
              width: "100%",
              height: "100%",
              borderRadius: isCustomIcon ? "3px" : "50%",
              borderWidth: "1.2px",
              borderColor:
                isDone || isCustomIcon ? "transparent" : "primary.solid",
              backgroundColor:
                isDone || isCustomIcon ? "primary.soft" : undefined,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {taskKey === "dashboard" || taskKey === "thoughtmap" ? (
              <MapIcon />
            ) : taskKey === "progress" ? (
              <ProgressIcon />
            ) : (
              isDone && <CheckIcon />
            )}
          </Stack>
        </Box>
      </ListItemDecorator>
      <ListItemContent>
        <Typography>{title}</Typography>
      </ListItemContent>

      {isLocked && <LockChip />}
      {isCoach && hasMissingValue && <IncompleteChip />}
    </ListItemButton>
  );
}

export default memo(TaskItem);
